import { Component, EventEmitter, Input, Output, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { SectionComponent } from '../../../../shared/components/structure/section/section.component';
import {
    RadioEnhancedComponent
} from '../../../../shared/components/controls/ui-controls/radio-enhanced/radio-enhanced.component';
import { NachrichtenTypeEnum } from '../../../../core/model/nachricht/nachrichten-type.enum';
import { RadioOption } from '../../../../shared/components/controls/ui-controls/radio-enhanced/radio-option';
import { I18NextPipe } from '@kokos-i18next';
import i18next from 'i18next';

@Component({
    selector: 'kokos-dienststellen-selector',
    imports: [
        SectionComponent,
        RadioEnhancedComponent,
        I18NextPipe
    ],
    templateUrl: './dienststellen-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class DienststellenSelectorComponent implements OnInit, OnDestroy {

    @Input() nachrichtenType: NachrichtenTypeEnum;

    @Output() nachrichtenTypeChanged =
        new EventEmitter<NachrichtenTypeEnum.AA | NachrichtenTypeEnum.JC>();

    nachrichtenTypeOptions: RadioOption[] = [];

    private readonly languageChangedHandler = () => {
        this.buildNachrichtenTypeOptions();
    };

    ngOnInit(): void {
        this.buildNachrichtenTypeOptions();
        i18next.on('languageChanged', this.languageChangedHandler);
    }

    ngOnDestroy(): void {
        i18next.off('languageChanged', this.languageChangedHandler);
    }

    private buildNachrichtenTypeOptions(): void {
        this.nachrichtenTypeOptions = [
            {
                label: i18next.t('sendmail.prepare.step.aa'),
                value: NachrichtenTypeEnum.AA,
                image: 'assets/redd/images/mailbox-logo-ba.png',
                infos: [
                    i18next.t('sendmail.prepare.step.aa-unemployment-benefit'),
                    i18next.t('sendmail.prepare.step.aa-insolvency-benefit'),
                    i18next.t('sendmail.prepare.step.aa-vocational-training-assistance'),
                    i18next.t('sendmail.prepare.step.aa-terminate-benefit')
                ]
            },
            {
                label: i18next.t('sendmail.prepare.step.jc'),
                value: NachrichtenTypeEnum.JC,
                image: 'assets/redd/images/mailbox-logo-jc.png',
                infos: [
                    i18next.t('sendmail.prepare.step.jc-citizen-benefit'),
                    i18next.t('sendmail.prepare.step.jc-housing-needs'),
                    i18next.t('sendmail.prepare.step.jc-education-participation'),
                    i18next.t('sendmail.prepare.step.jc-terminate-benefit')
                ]
            }
        ];
    }
}